// #region Global Imports
import styled from "styled-components";
// #endregion Global Imports

export const Container = styled.div`
    background-color: ${({ theme }) => theme.colors.primary};
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    justify-content: flex-start;
    align-items: center;
    min-height: 100vh;
`;

export const Top = styled.div`
    margin: 100px;
`;

export const Middle = styled.div`
    text-align: center;
    display: flex;
    flex: 1 1 100%;
    width: 100%;
    justify-content: flex-start;
`;

export const MiddleLeft = styled.div`
    display: flex;
    flex: 1 1 1%;
`;

export const MiddleLeftButtons = styled.div`
    background: #f9da2e;
    border-radius: 8px;
    font-family: Arial;
    font-weight: 700;
    font-size: 25px;
    color: #4b6c8d;
    letter-spacing: 0;
    width: 55px;
    height: 236px;
    margin-left: 15px;
    padding: 10px 3px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    color: #4b6c8d;

    .button {
        cursor: pointer;
    }

    .active {
        color: #2c3e50;
    }
`;

export const MiddleRight = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
`;

export const Apod = styled.div`
    display: flex;
    flex: 1 1 100%;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
`;

export const ApodButton = styled.div`
    background: #f9da2e;
    border-radius: 5px;
    padding: 5px 10px;
    font-family: Arial;
    font-weight: 700;
    font-size: 25px;
    color: ${({ theme }) => theme.colors.primary};
    letter-spacing: 0;
`;

export const TopText = styled.div`
    font-size: 110px;
    font-family: Arial, Helvetica, sans-serif;
    color: #ffffff;
    margin-bottom: 10px;
`;

export const TendbeLogo = styled.div`
    height: 100px;
    width: 100px;
    background-repeat: none;
    background-size: contain;
    background-image: url("/images/tb-icon.png");
    margin: auto;
`;

export const NewPoll = styled.img`
    height: 60px;
    width: 60px;
    position: fixed;
    bottom: 20px;
    right: 16px;
    z-index: 9;
    cursor: pointer;
    @media (min-width: 1025px) {
        left: 50%;
        margin-left: 436px;
        bottom: 20px;
    }
`;

export const NoPollsMessage = styled.p`
    color: ${({ theme }) => theme.palette.common.gray};
    font-size: 20px;
    > svg {
        font-size: 40px;
    }
`;
